export const messages = {
  NO_UNKNOWN: 'The key in your custom data are not a valid one.',
  MIN_LEN: 'The value should have at least ${min} chars.',
  MIN_NUM: 'The value should be minimum ${min}.',
  MAX_NUM: 'The value should be maximum ${max}.',
  EQUAL: 'The value should be ${length} cars long.',
  NO_INT: 'The value is not a number',
};
